// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8syOw","content":"styles_content__53MW2","tableWrap":"styles_tableWrap__2_jnH"};